import React from 'react';
import { Link } from 'react-router-dom';
import { Wordmark } from './Wordmark';
interface AuthLayoutProps {
  title: string;
  subtitle: string;
  children: React.ReactNode;
  aside: React.ReactNode;
  footer?: React.ReactNode;
}
export function AuthLayout({
  title,
  subtitle,
  children,
  aside,
  footer
}: AuthLayoutProps) {
  return <div className="min-h-full w-full bg-surface" data-id="element-158" data-mp="10cpfk2i9nugt">
      <div className="mx-auto grid w-full max-w-[1080px] gap-12 px-5 py-10 sm:px-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16 lg:py-16" data-id="element-159" data-mp="venujc1a5l2p">
        <div className="flex flex-col" data-id="element-160" data-mp="qmnp542fxzyq">
          <Link to="/" className="inline-flex items-center gap-2 self-start focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand" data-id="element-161" data-mp="qlme2zlfddh0">
            <Wordmark size="md" data-id="element-162" data-mp="cnegqqkh8a5b" />
          </Link>

          <div className="mt-10 max-w-md" data-id="element-163" data-mp="cmv0rfedzvtx">
            <h1 className="text-[1.7rem] font-semibold leading-tight tracking-tight text-ink sm:text-[1.9rem]" data-id="element-164" data-mp="7otkf28ciam5">
              {title}
            </h1>
            <p className="mt-2.5 text-[15px] leading-relaxed text-ink-muted" data-id="element-165" data-mp="2y1zsvy8tiq1c">
              {subtitle}
            </p>
            <div className="mt-8" data-id="element-166" data-mp="32wceoexrodg9">{children}</div>
            {footer && <div className="mt-6 border-t border-line pt-5 text-[13px] text-ink-muted" data-id="element-167" data-mp="2p4ftyvyfh5tw">
                {footer}
              </div>}
          </div>
        </div>

        <div className="lg:pt-[68px]" data-id="element-168" data-mp="3gv3uc5sa276i">{aside}</div>
      </div>
    </div>;
}